import { Error } from 'pages/error';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { usePopoverElectron } from 'shared/hooks/use-popover-electron';

import { CreateTask, CreateTaskLoader } from './create-task';
import * as Styled from './task-create.style';

export const TaskCreatePage: React.FC = () => {
  const { isPopoverElectron, onClose } = usePopoverElectron();
  const [name, setName] = React.useState('');

  const _onClose = () => onClose?.();

  useKeysDown(['Escape'], _onClose, { otherKeysInCombinationAllowed: true });
  return isPopoverElectron ? (
    <Styled.Container>
      <ErrorBoundary fallback={<Error />}>
        <Suspense
          fallback={<CreateTaskLoader name={name} updateName={setName} />}
        >
          <CreateTask name={name} updateName={setName} />
        </Suspense>
      </ErrorBoundary>
    </Styled.Container>
  ) : (
    <Error />
  );
};
